import { render, staticRenderFns } from "./DetailsSectionKPOPdf.vue?vue&type=template&id=70dcbe6f&"
import script from "./DetailsSectionKPOPdf.vue?vue&type=script&lang=js&"
export * from "./DetailsSectionKPOPdf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports